export class SidebarMenu {
    constructor () {}

    init() {
        let _this = this;
        _this.bindEvents();
    }

    bindEvents() {
        let _this = this;
        _this.bindSidebarHref();
        _this.bindHashChange();
        _this.bindBSTabChange();
    }

    bindSidebarHref = function () {
        $('.sidebar-navigation ul li a').click(function(e) {
            e.preventDefault();
            let $targetElem = $(e.target);

            if ($targetElem.hasClass('expand-submenu')) {
                let $parentLi = $targetElem.parents('li').first();
                if ($parentLi.hasClass('expanded')) {
                    $parentLi.removeClass('expanded');
                } else {
                    $('.sidebar-navigation li.expanded').removeClass('expanded');
                    $parentLi.addClass('expanded');
                }
            } else {
                location.href = $(this).attr('href');
            }
        });
    }

    bindHashChange = function () {
        let _this = this;
        $(window).on( 'hashchange', function( e ) {
            setTimeout(function() {
                _this.activateSidebarSubmenuLink();
            }, 500);
        });
        $(window).on( 'load', function( e ) {
            setTimeout(function() {
                _this.activateSidebarSubmenuLink();
            }, 500);
        });
    }

    bindBSTabChange = function () {
        let _this = this;
        $('.nav-tabs a').on('shown.bs.tab', function (e) {
            setTimeout(function() {
                _this.activateSidebarSubmenuLink();
            }, 500);
        });
    }

    activateSidebarSubmenuLink = function () {
        let currentHash = window.location.hash;
        let currentHashVal = currentHash.replace('#', '');
        if (currentHashVal == '') {
            return;
        }

        let $activeTabLink = $('.sidebar-navigation .level-2 a.'+currentHashVal);
        if ($activeTabLink.length) {
            let $parentUl = $activeTabLink.parents('.level-2');
            $parentUl.find('li.active').removeClass('active');

            $activeTabLink.parents('li').first().addClass('active');
        }
    }
}